/**
 * Security Report PDF Hook using React Query
 *
 * Handles on-demand PDF download for the latest security scan report.
 */

import { useMutation } from '@tanstack/react-query';
import { getSecurityReportPdf } from '@/services/security-scanner';

/**
 * Mutation hook to fetch the latest security scan report as a PDF blob.
 *
 * @example
 * const { mutateAsync: downloadPdf, isPending } = useSecurityReportPdf();
 * const blob = await downloadPdf({ org_id, user_id });
 */
export function useSecurityReportPdf() {
  return useMutation({
    mutationFn: (params: { org_id: string | number; user_id: string | number }) =>
      getSecurityReportPdf(params),
  });
}
